"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ScrollableContainer.css");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var ScrollableContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollableContainer, _React$Component);
  var _super = _createSuper(ScrollableContainer);
  function ScrollableContainer(props) {
    var _this;
    _classCallCheck(this, ScrollableContainer);
    _this = _super.call(this, props);
    _this.option = _this.props.vertical && _this.props.horizontal || _this.props.both ? "scrollable Both" // Both directions scrolling
    : _this.props.vertical ? "scrollable Vertical" // Only vertical scrolling
    : _this.props.horizontal ? "scrollable Horizontal" // Only horizontal scrolling
    : "scrollable"; // no scrolling
    return _this;
  }
  _createClass(ScrollableContainer, [{
    key: "showScrollBars",
    value: function showScrollBars(e) {
      // function to show scrollBars onMouseOver in firefox
      var elem = e.target;
      while (!elem.classList.contains("scrollable")) {
        elem = elem.parentNode.querySelector(".scrollable") || elem.parentNode;
      }
      if (this.props.vertical || this.props.both) {
        elem.scrollTop += 1;
        elem.scrollTop -= 1;
      } else {
        elem.scrollLeft += 1;
        elem.scrollLeft -= 1;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var scrollBars = [];

      // adding vertical scrollBar
      if (this.props.vertical || this.props.both) scrollBars.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: "vertical-scroll-mask",
        className: "vertical-scroll-mask",
        style: {
          backgroundColor: this.props.backgroundColor || "white"
        }
      }));

      // adding horizontal scrollBar
      if (this.props.horizontal || this.props.both) scrollBars.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "horizontal-scroll-mask",
        key: "horizontal-scroll-mask",
        style: {
          backgroundColor: this.props.backgroundColor || "white"
        }
      }));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "scrollable-container " + this.props.containerClassName,
        id: this.props.id
      }, scrollBars, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.option + " " + this.props.scrollableClassName,
        onMouseOver: function onMouseOver(e) {
          return _this2.showScrollBars(e);
        },
        style: {
          backgroundColor: this.props.backgroundColor
        }
      }, this.props.children));
    }
  }]);
  return ScrollableContainer;
}(_react["default"].Component);
var _default = exports["default"] = ScrollableContainer;